import {useQuery} from "@tanstack/react-query";
import workspaceRepository from "../../respsitory/WorkspaceRepository";
import {WorkspaceAggregation} from "@/model/workspace";

const getData = async (workspaceId: string) => {
    try {
        const { data } = await workspaceRepository.read(workspaceId);
        return data.result;
    } catch (e) {
        throw e;
    }
}

const useWorkspaceAggregation = (workspaceId?: string) => {
    return useQuery<WorkspaceAggregation, Error>({
        enabled: !!workspaceId,
        queryKey: ['workspace', workspaceId],
        queryFn: async () => getData(workspaceId!),
        retry: false,
        suspense: false,
    })
}

export default useWorkspaceAggregation;
